export default __webpack_public_path__ + "static/13-527a646d951ca0589810a5070f895ad8.png";